import React from 'react';
import useGradualQualityImageSource from '../../hooks/useGradualQualityImageSource';
import { getImageMaxHeight, getImageHeight, getImageMaxWidth, isImageWide } from '../../utils';
import { CLICK_THRESHOLD_AREA, ImageSizeType } from '../../consts';
import { doTrack } from '../../analytics';
import { logError } from '../../error';
export const Banner = ({ href, image, imageSize = ImageSizeType.SMALL, index, onClick, setLoaded, target, title, }) => {
    const { src, base64 } = image;
    const anchorRef = React.useRef(null);
    const anchorStyle = {
        height: !isImageWide(imageSize) ? getImageHeight({ imageSize }) : undefined,
        maxHeight: !isImageWide(imageSize) ? getImageMaxHeight({ imageSize }) : undefined,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
    };
    const imageStyle = {
        width: isImageWide(imageSize) ? '100%' : undefined,
        maxWidth: isImageWide(imageSize) ? getImageMaxWidth({ imageSize }) : '100%',
    };
    const isLazy = index > 1;
    const [source] = useGradualQualityImageSource(base64, src);
    const loading = !isLazy ? 'eager' : 'lazy';
    const onLoad = !isLazy ? () => setLoaded(true) : undefined;
    let eventCoords = [undefined, undefined];
    const handleOnMouseUp = async (e) => {
        const diffX = Math.abs(e.pageX - eventCoords[0]);
        const diffY = Math.abs(e.pageY - eventCoords[1]);
        if (diffX < CLICK_THRESHOLD_AREA && diffY < CLICK_THRESHOLD_AREA) {
            try {
                await doTrack({ index, title });
            }
            catch (error) {
                logError({ error, metadata: { index } });
            }
            if (onClick) {
                onClick();
            }
            else {
                anchorRef.current.click();
            }
        }
    };
    const handleOnMouseDown = (e) => {
        eventCoords = [e.pageX, e.pageY];
    };
    return (React.createElement("div", { onMouseUp: handleOnMouseUp, onMouseDown: handleOnMouseDown },
        React.createElement("a", { ref: anchorRef, href: href, title: title, target: target, style: anchorStyle },
            React.createElement("img", { alt: "" // TODO: we should consider having this as an additional image field in contentstack
                , draggable: false, loading: loading, onLoad: onLoad, src: source, style: imageStyle }))));
};
